import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Breakdown } from '../../../templates/Breakdown';

export const PeriodicPayBackMore: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicPayBackMore.${label}.${locale}.json`)}>
      <PeriodicPayBackMoreComponent />
    </I18nProvider>
  );
};

export const PeriodicPayBackMoreComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicPayBackMore'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Breakdown
      title={t('periodicPayBackMore.title')}
      content={t('periodicPayBackMore.content')}
      buttonHref={t('periodicPayBackMore.buttonLink.href')}
      buttonText={t('periodicPayBackMore.buttonLink.text')}
      footerLabel={t('periodicPayBackMore.priceDetailsFooterLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicPayBackMore.imageSrc')}`,
        },
      }}
    />
  );
};
